import React from 'react';
import cn from 'classnames';
import upperFirst from 'lodash/upperFirst';
import {
  useTopCompanyCommonContext,
} from '@/finsight/application/TopCompanies/topCompaniesCommon/TopCompaniesCommonContext';
import {
  ISSUER_NAME,
  RATING_AGENCY_NAME,
  UNDERWRITER_NAME,
} from '@/finsight/ui/common/components/TopCompanies/constants';
import CheckUserPlanAccess from '@/finsight/ui/common/components/CheckUserPlanAccess';
import { UserPlanType } from '@/users/domain/UserPlan';

import styles from './styles.scss';

const TOP_COMPANIES_TABS = [
  {
    name: ISSUER_NAME,
    title: 'Issuers',
  },
  {
    name: RATING_AGENCY_NAME,
    title: 'Rating Agencies',
  },
  {
    name: UNDERWRITER_NAME,
    title: 'Underwriters',
  },
];

const TopCompaniesTabs = () => {
  const {
    activeTab,
    setActiveTab,
  } = useTopCompanyCommonContext();

  return (
    <CheckUserPlanAccess
      requiredUserPlan={ UserPlanType.STARTER }
      fallback={ (
        <>
          <div className={ styles.tabsWrapper }>
            { TOP_COMPANIES_TABS.map(({ name, title }) => (
              <div
                key={ name }
                className={ cn(styles.tabItem, {
                  [styles.activeTab]: name === activeTab,
                  [styles.disabledTab]: name !== activeTab,
                }) }
                data-test={ `topCompaniesTabs${ upperFirst(name) }` }
              >
                { title }
              </div>
            )) }
          </div>
          <div className={ styles.tabsFooter } />
        </>
      ) }
    >
      <>
        <div className={ styles.tabsWrapper }>
          { TOP_COMPANIES_TABS.map(({ name, title }) => (
            <div
              key={ name }
              className={ cn(styles.tabItem, {
                [styles.activeTab]: name === activeTab,
              }) }
              onClick={ () => setActiveTab(name) }
              data-test={ `topCompaniesTabs${ upperFirst(name) }` }
            >
              { title }
            </div>
          )) }
        </div>
        <div className={ styles.tabsFooter } />
      </>
    </CheckUserPlanAccess>
  );
};

export default TopCompaniesTabs;
